export default ['separated', 'combined', 'absent'];
